import { makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { BarChart } from "../../../../components/charts/BarChart";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { consumptionData } from "../sample";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
}));

export const DecreasingConsumptionAlert = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title="Decreasing Consumption Alert"
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FCF3D9">
        <Typography variant="h4">
          Power consumption decrease throughout the last 6months
        </Typography>
      </InfoBox>

      <Typography className={classes.chartTitle}>
        Consumption over 2021
      </Typography>
      <BarChart height={120} barSize={10} chartData={consumptionData} />

      <GroupButton
        buttons={[
          { text: "SHARE" },
          { text: "VIEW REPORT" },
          { text: "EXPORT SAME TYPE ALERTS" },
        ]}
      />
    </Box>
  );
};
